<template>
  <Preloader v-if="isInfoLoading" />
  <div class="student-year" v-else>
    <p class="student-year__info">
      Скачать файл
      <a href="../documents/agreement_dg.docx" target="_blank">
        "Согласие родителя на обработку персональных данных”
      </a>
      <br />
      Все документы необходимо загружать с персонального компьютера или ноутбука
      во избежание технических неполадок
    </p>
    <DocsComponent
      :type="'education'"
      :project="true"
      :current-project="currentProject"
      :is_disabled="isDisabled || isBtnDisabled"
      :category_id="currentCategoryId || currentCategoryData?.info_category.id"
      :nomination_id="
        type === 'individual'
          ? AYindividualNominationValue
          : AYgranprixNominationValue
      "
      @docs-changed="docsChanged"
      @up-docs="(value) => (educationDocs = value)"
    />
    <p class="student-year__info">
      Чтобы преобразовать изображение в формат PDF или сжать файл любого
      формата, воспользуйтесь поисковой системой для нахождения соответствующих
      <a
        href="https://ya.ru/search/?text=%D0%BA%D0%BE%D0%BD%D0%B2%D0%B5%D1%80%D1%82%D0%B5%D1%80+%D0%B2+pdf&lr=236"
        target="_blank"
      >
        онлайн-сервисов
      </a>
    </p>
    <div class="student-year__btn" v-if="!isDisabled">
      <Button @click="saveInfo" :loading="isBtnLoading">
        Сохранить изменения
      </Button>
      <Button secondary v-if="false">Сохранить как черновик</Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Blocks/Button";
import Preloader from "@/components/Blocks/Preloader";
import useVuelidate from "@vuelidate/core";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { createRequest } from "@/api/requestBuilder";
import requestConfigs from "@/api/requestConfigs";
import DocsComponent from "@/components/Blocks/DocsComponent";

export default {
  name: "AchievementYearIndividualPerformance",
  components: { DocsComponent, Preloader, Button },
  setup() {
    return {
      v$: useVuelidate({ $lazy: true }),
    };
  },
  props: ["currentProject", "type"],
  data() {
    return {
      isBtnLoading: false,
      isBtnDisabled: false,
      isFormValidate: false,
      educationDocs: [],
      errors: [],
      formData: {
        document_student_billet: "",
        document_student_record_book_main_page: "",
        document_student_record_book_session_pages_one: "",
        document_student_record_book_session_pages_two: "",
        document_student_record_book_session_pages_three: "",
        document_student_record_book_session_pages_four: "",
        document_student_record_book_session_pages_five: "",
        document_reference: "",
        document_higher_education: "",
        document_social_need: "",
        document_certificate_absence_academic_debt: "",
        document_certificate_guardianship_adoption: "",
        document_certificate_family_composition: "",
        document_reference_scholarship_amount: "",
        document_certificate_personal_income_student_last_3_months: "",
        document_consent_parents: "",
        document_reference_income_parent_one: "",
        document_reference_income_parent_two: "",
      },
    };
  },
  watch: {
    async user() {
      await this.loadInfo();
      await this.setProjectEducationData();
    },
    docs: {
      handler: function () {
        Object.keys(this.formData).forEach((item) => {
          return (this.formData[item] = this.docs[item]);
        });
      },
      deep: true,
    },
    disabledFields: {
      handler: function () {
        if (this.type === "individual") {
          this.isFormValidate =
            this.disabledFields["isAYIndividualEducationFilled"];
        }
        if (this.type === "collective") {
          this.isFormValidate =
            this.disabledFields["isAYCollectiveEducationFilled"];
        }
        if (this.type === "granprix") {
          this.isFormValidate =
            this.disabledFields["isAYGranprixEducationFilled"];
        }
      },
      deep: true,
    },
  },
  computed: {
    isDisabled() {
      let boolean;
      if (Object.values(this.currentCategoryData).length > 0) {
        if (this.validPeriodForRollback) {
          if (this.currentCategoryData?.status?.key === 0) {
            boolean = false;
          } else boolean = this.currentCategoryData?.status?.key !== 35;
        } else if (this.validPeriodFor35Status) {
          boolean = this.currentCategoryData?.status?.key !== 35;
        } else return true;
      }
      return this.isOldApplication || boolean;
    },
    openRegistrationStage() {
      return this.currentProject?.settings?.stages?.data.find((item) => {
        return item.stage_key === "open_registration";
      });
    },
    checkStatementEmployee() {
      return this.currentProject?.settings?.stages?.data.find((item) => {
        return item?.stage_key === "check_statement_employee";
      });
    },

    validPeriodForRollback() {
      return moment().isBetween(
        moment(this.openRegistrationStage?.start_at),
        moment(this.openRegistrationStage?.end_at),
        "day",
        "[]"
      );
    },
    validPeriodFor35Status() {
      return moment().isBetween(
        moment(this.checkStatementEmployee?.start_at),
        moment(this.checkStatementEmployee?.end_at),
        "day",
        "[]"
      );
    },
    ...mapState("user", ["user", "disabledFields", "isInfoLoading"]),
    ...mapState([
      "currentCategoryData",
      "docs",
      "statementId",
      "currentCategoryId",
      "storage",
      "isOldApplication",
      "AYindividualNominationValue",
      "AYgranprixNominationValue",
    ]),
    ...mapGetters(["isAllDocsLabels", "socialDocs"]),
  },
  methods: {
    async setFakeUserData() {
      this.educationDocs.forEach((item) => {
        if (typeof this.formData[item.key_document] === "object")
          this.user.education.document_files[item.key_document].full =
            this.formData[item.key_document];
      });
    },
    loadInfo() {
      if (this.user.education) {
        Object.keys(this.formData).forEach((item) => {
          if (
            this.user.education.document_files[item] &&
            this.user.education.document_files[item].thumb
          ) {
            return (this.formData[item] =
              this.user.education.document_files[item]);
          } else return (this.formData[item] = this.docs[item]);
        });
      }
      if (this.type === "individual") {
        this.isFormValidate =
          this.disabledFields["isAYIndividualEducationFilled"];
      }
      if (this.type === "collective") {
        this.isFormValidate =
          this.disabledFields["isAYCollectiveEducationFilled"];
      }
      if (this.type === "granprix") {
        this.isFormValidate =
          this.disabledFields["isAYGranprixEducationFilled"];
      }
    },
    async saveInfo() {
      if (this.errors?.length > 0) {
        this.$store.dispatch("validationErrors", {
          errors: this.errors,
          fieldsInfo: this.isAllDocsLabels,
        });
        return;
      }

      const needValidationDocsBefore = await this.$store.dispatch(
        "user/getNeedValidationDocuments"
      );

      let payloadObject = {};
      Object.keys(this.formData).forEach((item) => {
        if (
          this.user?.education?.document_files[item]?.thumb &&
          this.formData[item].thumb
        ) {
          this.formData[item] = "";
        } else {
          if (this.user.info_validation_documents.data.length > 0) {
            let infoDocument = this.user.info_validation_documents.data.find(
              (i) => {
                return i.key_document === item;
              }
            );
            if (infoDocument) {
              infoDocument.status = 0;
            }
          }
        }
        if (this.formData[item]) {
          return (payloadObject[item] = this.formData[item]);
        }
      });

      this.isBtnDisabled = false;
      this.isBtnLoading = false;

      await createRequest(requestConfigs.POSTSaveEducation, {
        jsonPayload: payloadObject,
      })
        .then(async (response) => {
          this.$store.commit("pushToTray", {
            text: "Данные успешно сохранены",
            type: "success",
          });
          Object.keys(response.data).forEach((item) => {
            if (this.socialDocs.includes(item)) {
              this.user.social_documents.document_files[item] =
                response.data[item];
            } else
              this.user.education.document_files[item] = response.data[item];
          });
          Object.keys(this.formData).forEach((item) => {
            if (this.socialDocs.includes(item)) {
              this.formData[item] =
                this.user?.social_documents?.document_files[item];
            } else
              this.formData[item] = this.user?.education?.document_files[item];
            this.docs[item] = "";
          });
          // await this.setFakeUserData();
          await this.setProjectEducationData();

          const needValidationDocsResult = await this.$store.dispatch(
            "user/getNeedValidationDocuments"
          );
          if (needValidationDocsBefore > 0 && needValidationDocsResult === 0) {
            this.$store.commit("setCurrentPopup", {
              name: "PopupSendStatement",
              isShown: true,
              props: { id: this.currentCategoryData?.id },
            });
            return;
          }

          if (this.type === "individual") {
            if (this.disabledFields["isAYIndividualEducationFilled"]) {
              this.$router.push({ name: "AchievementYearIndividualPortfolio" });
            }
          }
          if (this.type === "collective") {
            if (this.disabledFields["isAYCollectiveNominationFilled"]) {
              this.$router.push({ name: "AchievementYearCollectivePortfolio" });
            }
          }
          if (this.type === "granprix") {
            if (this.disabledFields["isAYGranprixEducationFilled"]) {
              this.$router.push({ name: "AchievementYearGrandPrixPortfolio" });
            }
          }
        })
        .catch((error) => {
          this.$store.commit("pushToTray", {
            text: error.errors[0].error_descr,
            type: "error",
          });
        })
        .finally(() => {
          this.isBtnDisabled = false;
          this.isBtnLoading = false;
        });
    },
    async setProjectEducationData() {
      if (this.type === "individual") {
        this.$store.dispatch("user/checkProjectValidation", [
          this.educationDocs
            .filter((i) => {
              return i.is_required;
            })
            .map((item) => {
              return item.key_document;
            }),
          "isAYIndividualEducationFilled",
          "education",
        ]);
      }
      if (this.type === "collective") {
        this.$store.dispatch("user/checkProjectValidation", [
          this.educationDocs
            .filter((doc) => {
              return doc.is_required;
            })
            .map((item) => {
              return item.key_document;
            }),
          "isAYCollectiveEducationFilled",
          "education",
        ]);
      }
      if (this.type === "granprix") {
        this.$store.dispatch("user/checkProjectValidation", [
          this.educationDocs
            .filter((i) => {
              return i.is_required;
            })
            .map((item) => {
              return item.key_document;
            }),
          "isAYGranprixEducationFilled",
          "education",
        ]);
      }
    },
    docsChanged(value, errors) {
      this.isFormValidate = value;
      this.errors = errors;
    },
  },
  async mounted() {
    await this.loadInfo();
    await this.setProjectEducationData();
    Object.keys(this.formData).forEach((item) => {
      this.$store.commit("setDocument", ["", item]);
    });
  },
};
</script>

<style scoped></style>
